/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FittingTreeViewComponent } from './fitting-tree-view.component';
import { DxTreeViewModule } from 'devextreme-angular';

@NgModule({
  declarations: [FittingTreeViewComponent],
  imports: [CommonModule, DxTreeViewModule],
  exports: [FittingTreeViewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FittingTreeViewModule {}
